export const siteInfo = {
  name: '琪琪影院',
  tagline: '韩剧国产剧全覆盖 · 高清在线免费看不缓冲',
  description: '琪琪影院是一个专注电视剧在线观看的平台，汇聚电视剧全集、最新电视剧和热门电视剧，韩剧、国产剧全覆盖。高清画质在线免费观看不缓冲，每日同步更新，追剧首选平台。',
};

export const navItems = [
  { label: '精选专题', href: '#index' },
  { label: '手机追剧', href: '#app' },
  { label: '精彩片花', href: '#media' },
  { label: '剧集推荐', href: '#cards' },
  { label: '追剧热评', href: '#comments' },
  { label: '焦点推荐', href: '#carousel' },
];

export const heroStats = [
  { label: '热播剧集', value: '2000+' },
  { label: '每日更新', value: '30+集' },
  { label: '高清画质', value: '1080P' },
];

export const appEntry = {
  title: '手机追剧随时随地',
  subtitle: '琪琪影院移动端',
  description: '支持手机、平板多终端同步观看，随时随地畅享最新电视剧全集，回家路上、午休时间都不错过任何一集精彩内容。',
  features: ['离线缓存', '小窗播放', '投屏电视', '弹幕互动'],
};

export const mediaCards = [
  {
    title: '《月升沧海》精彩预告',
    category: '国产剧',
    duration: '02:35',
    views: '128万',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Chinese%20historical%20drama%20scene%20with%20elegant%20hanfu%20costumes%2C%20moonlit%20palace%20courtyard%2C%20warm%20golden%20lantern%20light%2C%20cinematic%20composition%2C%20soft%20atmospheric%20lighting%2C%20emotional%20intensity%2C%20high%20production%20value&width=800&height=450&seq=media-01&orientation=landscape',
  },
  {
    title: '《首尔之夜》高能片段',
    category: '韩剧',
    duration: '03:18',
    views: '96万',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20Korean%20drama%20night%20cityscape%20scene%20with%20neon%20lights%2C%20two%20characters%20on%20rooftop%2C%20emotional%20moment%2C%20soft%20bokeh%20background%2C%20cinematic%20warm%20tones%2C%20romantic%20atmosphere%2C%20high%20quality%20drama%20still&width=800&height=450&seq=media-02&orientation=landscape',
  },
  {
    title: '《长安十二时辰》幕后花絮',
    category: '国产剧',
    duration: '05:42',
    views: '203万',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20market%20street%20scene%20with%20elaborate%20period%20costumes%2C%20bustling%20crowd%2C%20warm%20torch%20and%20lantern%20lighting%2C%20cinematic%20wide%20angle%2C%20epic%20scale%2C%20detailed%20production%20design%2C%20atmospheric&width=800&height=450&seq=media-03&orientation=landscape',
  },
  {
    title: '《暗夜追踪》首集抢先看',
    category: '韩剧',
    duration: '01:52',
    views: '67万',
    image: 'https://readdy.ai/api/search-image?query=Suspenseful%20Korean%20thriller%20drama%20scene%20in%20rainy%20Seoul%20alleyway%2C%20mysterious%20silhouette%2C%20wet%20reflective%20pavement%2C%20moody%20blue%20and%20amber%20lighting%2C%20cinematic%20noir%20style%2C%20high%20tension%20atmosphere&width=800&height=450&seq=media-04&orientation=landscape',
  },
];

export const indexTopics = [
  {
    title: '2026暑期档热播剧',
    count: 24,
    tag: '热门',
    image: 'https://readdy.ai/api/search-image?query=Summer%20vibes%20drama%20collection%20collage%20with%20warm%20sunny%20tones%2C%20multiple%20drama%20poster%20thumbnails%20arranged%20artistically%2C%20golden%20hour%20lighting%2C%20cozy%20viewing%20atmosphere%2C%20entertainment%20theme&width=600&height=340&seq=index-01&orientation=landscape',
  },
  {
    title: '高分韩剧必看清单',
    count: 18,
    tag: '精选',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20poster%20wall%20with%20elegant%20composition%2C%20soft%20pastel%20tones%2C%20romantic%20and%20dramatic%20stills%2C%20clean%20modern%20aesthetic%2C%20warm%20lighting%2C%20premium%20entertainment%20collection&width=600&height=340&seq=index-02&orientation=landscape',
  },
  {
    title: '国产古装剧经典回顾',
    count: 32,
    tag: '经典',
    image: 'https://readdy.ai/api/search-image?query=Classic%20Chinese%20historical%20costume%20drama%20collection%2C%20elegant%20traditional%20hanfu%2C%20ink%20wash%20painting%20style%20background%2C%20golden%20and%20crimson%20color%20palette%2C%20artistic%20layout%2C%20cultural%20aesthetic&width=600&height=340&seq=index-03&orientation=landscape',
  },
  {
    title: '悬疑刑侦剧大合集',
    count: 15,
    tag: '热播',
    image: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20drama%20mood%20board%20with%20dark%20mysterious%20atmosphere%2C%20blue%20and%20amber%20color%20contrast%2C%20investigation%20theme%2C%20dramatic%20shadow%20play%2C%20suspenseful%20visual%20style&width=600&height=340&seq=index-04&orientation=landscape',
  },
  {
    title: '甜宠爱情剧精选',
    count: 21,
    tag: '甜蜜',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20collection%20with%20soft%20pink%20and%20peach%20tones%2C%20couple%20moments%20collage%2C%20cherry%20blossom%20atmosphere%2C%20warm%20gentle%20lighting%2C%20sweet%20romantic%20aesthetic%2C%20clean%20composition&width=600&height=340&seq=index-05&orientation=landscape',
  },
  {
    title: '职场剧现实题材',
    count: 12,
    tag: '口碑',
    image: 'https://readdy.ai/api/search-image?query=Modern%20office%20workplace%20drama%20theme%20with%20professional%20characters%2C%20clean%20minimal%20office%20setting%2C%20natural%20daylight%2C%20contemporary%20urban%20aesthetic%2C%20realistic%20drama%20stills%2C%20warm%20neutral%20tones&width=600&height=340&seq=index-06&orientation=landscape',
  },
  {
    title: '周末一口气刷全集',
    count: 28,
    tag: '完结',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20home%20movie%20night%20setup%20with%20large%20screen%2C%20comfortable%20blanket%2C%20warm%20ambient%20lighting%2C%20snacks%2C%20binge%20watching%20vibe%2C%20relaxing%20atmosphere%2C%20entertainment%20lifestyle&width=600&height=340&seq=index-07&orientation=landscape',
  },
];

export const faqItems = [
  {
    question: '琪琪影院需要注册会员才能观看吗？',
    answer: '完全不需要！琪琪影院所有电视剧全集均免费在线观看，无需注册、无需登录、无需任何付费，打开即可享受高清流畅的追剧体验。',
  },
  {
    question: '琪琪影院的画质怎么样？支持高清播放吗？',
    answer: '琪琪影院全线支持1080P高清画质，部分热门电视剧提供超清4K片源。采用智能CDN加速技术，确保播放流畅不缓冲，带给您最佳的观影享受。',
  },
  {
    question: '韩剧和国产剧的更新速度如何？',
    answer: '韩剧和国产剧均与韩国及国内播出平台同步更新，热门剧集播出后2小时内即可在琪琪影院观看中文字幕版，让您第一时间追上最新剧情。',
  },
  {
    question: '可以在手机上观看琪琪影院吗？',
    answer: '当然可以！琪琪影院完美适配手机、平板和电脑端，支持iOS和Android系统。您还可以使用投屏功能将电视剧推送到电视大屏上观看，享受家庭影院体验。',
  },
  {
    question: '琪琪影院的剧集资源齐全吗？',
    answer: '琪琪影院拥有海量电视剧资源库，涵盖近十年的热门韩剧、经典国产剧、热播新剧等超过2000部作品。无论是经典老剧还是最新热播剧，都能在这里找到。',
  },
  {
    question: '播放过程中遇到卡顿怎么办？',
    answer: '琪琪影院采用多线CDN智能分发技术，通常情况下播放流畅不缓冲。如偶遇卡顿，建议切换备用播放线路或降低一档清晰度，即可恢复流畅播放。',
  },
];

export const rankingItems = [
  { rank: 1, title: '月升沧海', category: '国产剧', hot: '987万', trend: 'up', tag: '热播中' },
  { rank: 2, title: '首尔之夜', category: '韩剧', hot: '856万', trend: 'up', tag: '新剧' },
  { rank: 3, title: '长安十二时辰', category: '国产剧', hot: '743万', trend: 'stable', tag: '经典' },
  { rank: 4, title: '暗夜追踪', category: '韩剧', hot: '691万', trend: 'up', tag: '热播中' },
  { rank: 5, title: '春日暖阳', category: '国产剧', hot: '628万', trend: 'up', tag: '新剧' },
  { rank: 6, title: '时光代理人', category: '韩剧', hot: '554万', trend: 'down', tag: '热播中' },
  { rank: 7, title: '锦绣未央', category: '国产剧', hot: '512万', trend: 'stable', tag: '经典' },
];

export const carouselItems = [
  {
    title: '《月升沧海》全网热播中',
    subtitle: '古装权谋巨制 · 豆瓣8.7分',
    description: '一段跨越山海的爱恨纠葛，朝堂之上的权谋较量，唯美画面与深情演绎交织，2026年最不容错过的国产古装大剧。',
    tag: '国产剧',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20drama%20scene%20with%20magnificent%20moonlit%20palace%2C%20flowing%20hanfu%20robes%2C%20dramatic%20cinematic%20lighting%2C%20starry%20night%20sky%2C%20grand%20scale%20composition%2C%20romantic%20and%20tragic%20atmosphere&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    title: '《首尔之夜》浪漫来袭',
    subtitle: '都市爱情韩剧 · 收视冠军',
    description: '首尔繁华夜景下的心动邂逅，两个灵魂在都市丛林中相遇、相知、相爱，每一帧都是壁纸级别的唯美画面。',
    tag: '韩剧',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20Seoul%20night%20cityscape%20with%20couple%20walking%20under%20neon%20lights%2C%20cherry%20blossoms%2C%20warm%20golden%20street%20lamps%2C%20cinematic%20depth%20of%20field%2C%20dreamy%20atmosphere%2C%20Korean%20drama%20aesthetic&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    title: '《长安十二时辰》经典重温',
    subtitle: '史诗级古装悬疑 · 口碑炸裂',
    description: '大唐盛世下的暗流涌动，十二时辰内拯救长安城的惊险之旅，精良制作与烧脑剧情完美结合，国产剧天花板之作。',
    tag: '国产剧',
    image: 'https://readdy.ai/api/search-image?query=Tang%20Dynasty%20Changan%20city%20panoramic%20view%20at%20sunset%2C%20ancient%20Chinese%20architecture%2C%20bustling%20streets%2C%20golden%20evening%20light%2C%20epic%20scale%2C%20historical%20drama%20cinematic%20quality%2C%20rich%20warm%20colors&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    title: '《暗夜追踪》悬疑烧脑',
    subtitle: '犯罪悬疑韩剧 · 反转不断',
    description: '一位刑警与犯罪心理专家的联手追凶之路，每集高能反转让人欲罢不能，韩剧悬疑题材的又一巅峰力作。',
    tag: '韩剧',
    image: 'https://readdy.ai/api/search-image?query=Suspenseful%20Korean%20crime%20drama%20scene%2C%20detective%20in%20dark%20alley%20with%20rain%2C%20moody%20blue%20lighting%2C%20reflection%20on%20wet%20ground%2C%20mysterious%20atmosphere%2C%20cinematic%20noir%20style%2C%20high%20contrast&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
  {
    title: '《春日暖阳》治愈之选',
    subtitle: '温情家庭国产剧 · 豆瓣8.5分',
    description: '一个普通家庭的温暖日常，三代人之间的理解与成长。没有狗血剧情，只有真实动人的生活点滴，治愈你的每一个疲惫夜晚。',
    tag: '国产剧',
    image: 'https://readdy.ai/api/search-image?query=Warm%20family%20drama%20scene%20in%20sunlit%20Chinese%20courtyard%20home%2C%20multi%20generation%20family%20gathering%2C%20spring%20blossoms%2C%20gentle%20afternoon%20light%2C%20cozy%20atmosphere%2C%20healing%2C%20realistic%20slice%20of%20life&width=1200&height=600&seq=carousel-05&orientation=landscape',
  },
  {
    title: '《时光代理人》奇幻穿越',
    subtitle: '奇幻爱情韩剧 · 话题之作',
    description: '穿越时空的信件连接两个时代的恋人，过去与现在的命运交织。新颖设定搭配精湛演技，引发全网追剧热潮的现象级作品。',
    tag: '韩剧',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20time%20travel%20Korean%20drama%20scene%2C%20vintage%20letter%20with%20glowing%20particles%2C%20warm%20nostalgic%20tones%2C%20magical%20atmosphere%2C%20old%20fashioned%20postbox%20in%20flower%20field%2C%20dreamy%20cinematic%20lighting&width=1200&height=600&seq=carousel-06&orientation=landscape',
  },
];

export const aboutInfo = {
  title: '关于琪琪影院',
  content: '琪琪影院成立于2020年，是深受剧迷喜爱的免费在线追剧平台。我们致力于为广大观众提供最新电视剧全集、热门电视剧的高清在线观看服务，韩剧、国产剧全覆盖，画质清晰流畅不缓冲。团队每日精心整理片源并同步更新，确保您不错过任何一部好剧。从经典老剧到最新热播，从古装权谋到现代都市，从悬疑烧脑到甜宠爱情，琪琪影院始终是您的追剧首选平台。',
  stats: [
    { value: '2000+', label: '电视剧资源' },
    { value: '500万+', label: '月活用户' },
    { value: '30+集', label: '每日更新' },
    { value: '98%', label: '好评率' },
  ],
};

export const topicItems = [
  { label: '月升沧海', hot: '987万', color: 'primary' },
  { label: '首尔之夜', hot: '856万', color: 'accent' },
  { label: '国产古装剧', hot: '743万', color: 'secondary' },
  { label: '韩剧推荐', hot: '691万', color: 'primary' },
  { label: '悬疑刑侦', hot: '628万', color: 'accent' },
  { label: '甜宠爱情', hot: '554万', color: 'secondary' },
  { label: '高分必看', hot: '512万', color: 'primary' },
  { label: '职场剧', hot: '438万', color: 'accent' },
  { label: '完结好剧', hot: '397万', color: 'secondary' },
];

export const featureItems = [
  {
    icon: 'ri-4k-fill',
    title: '高清画质',
    description: '全线支持1080P高清播放，热门剧集提供4K超清片源，画质细腻色彩饱满。',
  },
  {
    icon: 'ri-speed-up-fill',
    title: '流畅不缓冲',
    description: '多线CDN智能分发，自适应码率技术，网络不佳也能流畅追剧，告别卡顿。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    description: '手机、平板、电脑全平台适配，观影记录云端同步，随时随地继续追剧。',
  },
  {
    icon: 'ri-global-line',
    title: '海量资源',
    description: '2000+电视剧资源，韩剧国产剧全覆盖，经典老剧与新番热剧一网打尽。',
  },
  {
    icon: 'ri-timer-flash-fill',
    title: '极速更新',
    description: '与播出平台同步更新，热门剧集2小时内上线中字版，让你快人一步。',
  },
];

export const cardItems = [
  {
    title: '本周必看：五部高分国产剧推荐',
    excerpt: '精选豆瓣8分以上的口碑好剧，从古装权谋到现代职场，每一部都值得细细品味。',
    category: '国产剧',
    date: '2026-07-28',
    image: 'https://readdy.ai/api/search-image?query=Five%20Chinese%20drama%20posters%20arranged%20in%20elegant%20gallery%20wall%20style%2C%20warm%20spotlight%20illumination%2C%20dark%20luxurious%20background%2C%20premium%20curated%20collection%20feel%2C%20golden%20accents&width=600&height=400&seq=card-01&orientation=landscape',
  },
  {
    title: '韩剧迷六月追剧日历',
    excerpt: '整理本月即将上线和正在热播的韩剧清单，让你不错过任何一部精彩好剧。',
    category: '韩剧',
    date: '2026-07-25',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20calendar%20concept%20with%20elegant%20minimal%20design%2C%20monthly%20planner%20with%20drama%20stills%2C%20soft%20pastel%20pink%20and%20cream%20tones%2C%20clean%20organized%20layout&width=600&height=400&seq=card-02&orientation=landscape',
  },
  {
    title: '古装剧服化道大赏',
    excerpt: '盘点近年来国产古装剧中那些令人惊艳的服装、化妆和道具设计，每一件都是艺术品。',
    category: '国产剧',
    date: '2026-07-22',
    image: 'https://readdy.ai/api/search-image?query=Exquisite%20Chinese%20traditional%20hanfu%20costume%20display%20with%20intricate%20embroidery%20details%2C%20golden%20silk%20fabric%2C%20jewelry%20accessories%2C%20museum%20quality%20presentation%2C%20warm%20lighting&width=600&height=400&seq=card-03&orientation=landscape',
  },
  {
    title: '那些让人意难平的韩剧结局',
    excerpt: '盘点那些让观众又爱又恨、看完久久不能平复心情的经典韩剧大结局。',
    category: '韩剧',
    date: '2026-07-20',
    image: 'https://readdy.ai/api/search-image?query=Emotional%20Korean%20drama%20ending%20scene%20aesthetic%2C%20rainy%20window%20with%20soft%20focus%2C%20melancholy%20mood%2C%20warm%20amber%20light%2C%20nostalgic%20sentimental%20atmosphere%2C%20artistic%20blur&width=600&height=400&seq=card-04&orientation=landscape',
  },
  {
    title: '暑期档追剧指南',
    excerpt: '2026年暑期档最全追剧攻略，韩剧国产剧一网打尽，陪你度过炎炎夏日。',
    category: '综合',
    date: '2026-07-18',
    image: 'https://readdy.ai/api/search-image?query=Summer%20entertainment%20guide%20with%20colorful%20drama%20posters%20on%20tropical%20beach%20background%2C%20sunny%20vibrant%20colors%2C%20refreshing%20summer%20vibes%2C%20playful%20composition&width=600&height=400&seq=card-05&orientation=landscape',
  },
  {
    title: '刑侦剧TOP10：烧脑又过瘾',
    excerpt: '精选十部高智商犯罪悬疑剧，层层反转的剧情让你一口气追完停不下来。',
    category: '综合',
    date: '2026-07-15',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20crime%20drama%20top%20ten%20ranking%20visual%2C%20detective%20board%20with%20red%20strings%20connecting%20clues%2C%20dark%20moody%20lighting%2C%20investigation%20theme%2C%20dramatic%20shadow&width=600&height=400&seq=card-06&orientation=landscape',
  },
  {
    title: '一人分饰两角：演技炸裂名场面',
    excerpt: '盘点那些在剧中一人分饰多角的演员，精湛演技让人叹为观止的经典时刻。',
    category: '综合',
    date: '2026-07-12',
    image: 'https://readdy.ai/api/search-image?query=Split%20screen%20actor%20dual%20role%20concept%2C%20mirror%20reflection%20of%20same%20person%20in%20different%20costumes%2C%20dramatic%20stage%20lighting%2C%20theatrical%20atmosphere%2C%20black%20and%20gold%20color%20scheme&width=600&height=400&seq=card-07&orientation=landscape',
  },
];

export const updateItems = [
  { date: '2026-07-30', title: '《月升沧海》更新至第28集', type: '更新' },
  { date: '2026-07-29', title: '《首尔之夜》第14集上线', type: '更新' },
  { date: '2026-07-28', title: '新剧《暗夜追踪》全集上线', type: '新剧' },
  { date: '2026-07-27', title: '《春日暖阳》更新至第22集', type: '更新' },
  { date: '2026-07-26', title: '《时光代理人》大结局已更新', type: '完结' },
  { date: '2026-07-25', title: '新增4K超清片源：热门韩剧专区', type: '公告' },
  { date: '2026-07-24', title: '《锦绣未央》经典重温专区上线', type: '专题' },
  { date: '2026-07-23', title: '琪琪影院移动端体验全新升级', type: '公告' },
];

export const contactInfo = {
  title: '联系我们',
  description: '如果您有任何关于电视剧资源的建议、合作意向或问题反馈，欢迎通过以下方式与我们取得联系。我们珍视每一位剧迷的意见，期待与您一起打造更好的追剧平台。',
  email: 'contact@qiyicinema.com',
};

export const commentItems = [
  {
    name: '追剧小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Profile%20photo%20of%20young%20Asian%20woman%2C%20warm%20smile%2C%20soft%20natural%20lighting%2C%20clean%20simple%20background%2C%20portrait%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    date: '2天前',
    content: '琪琪影院真的太好用了！画质清晰不卡顿，韩剧更新速度也超快，终于不用到处找资源了，强烈推荐给所有追剧的朋友！',
    likes: 1283,
  },
  {
    name: '影视发烧友',
    avatar: 'https://readdy.ai/api/search-image?query=Profile%20photo%20of%20Asian%20man%20in%20his%2030s%2C%20friendly%20expression%2C%20casual%20style%2C%20clean%20background%2C%20portrait%20photography&width=80&height=80&seq=avatar-02&orientation=squarish',
    date: '3天前',
    content: '作为一个看了十几年剧的老观众，琪琪影院的资源库真的让我惊喜。很多经典老剧都能找到，画质还做了修复，太良心了。',
    likes: 967,
  },
  {
    name: '韩剧重度患者',
    avatar: 'https://readdy.ai/api/search-image?query=Profile%20photo%20of%20young%20Asian%20woman%20with%20stylish%20look%2C%20gentle%20smile%2C%20natural%20lighting%2C%20minimal%20background%2C%20portrait&width=80&height=80&seq=avatar-03&orientation=squarish',
    date: '5天前',
    content: '每天下班回家第一件事就是打开琪琪影院！韩剧更新速度跟韩国几乎同步，中文字幕质量也很高，翻译得很到位。',
    likes: 756,
  },
  {
    name: '剧荒终结者',
    avatar: 'https://readdy.ai/api/search-image?query=Profile%20photo%20of%20Asian%20man%20with%20glasses%2C%20intellectual%20look%2C%20warm%20smile%2C%20clean%20background%2C%20professional%20portrait&width=80&height=80&seq=avatar-04&orientation=squarish',
    date: '6天前',
    content: '之前总是剧荒不知道看什么，自从发现了琪琪影院的专题推荐，每天都有新剧可以追，而且推荐的质量真的很高！',
    likes: 621,
  },
  {
    name: '古装剧迷妹',
    avatar: 'https://readdy.ai/api/search-image?query=Profile%20photo%20of%20young%20Asian%20woman%20with%20elegant%20style%2C%20soft%20smile%2C%20warm%20lighting%2C%20simple%20background%2C%20portrait%20photography&width=80&height=80&seq=avatar-05&orientation=squarish',
    date: '7天前',
    content: '国产古装剧专区真的爱了！《月升沧海》每一帧都可以截图当壁纸，服化道太美了，琪琪影院的1080P画质完美呈现！',
    likes: 892,
  },
];